export default "__VITE_ASSET__DBkxB9rA__"